"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var either_1 = require("ayvri-std/lib/either");
var rollbar_1 = require("../helpers/rollbar");
// This constructs a client implementation from the given service. The type of the client
function client(service, transport) {
    var keys = Object.keys(service.props);
    // TODO: This is our dirty little hack. I'm not sure how
    // to go about constructing an instance of `ServiceInterface<P>`
    // without assigning through a partial.
    var impl = {};
    keys.forEach(function (k) {
        impl[k] = clientMethod(transport, service.props[k], k, service.codec);
    });
    // ;)
    return impl;
}
exports.client = client;
// Given a client transport, we execute the method invocation
function clientMethod(transport, rpcMethod, methodName, transportCodec) {
    var _this = this;
    return function (a) { return __awaiter(_this, void 0, void 0, function () {
        var payload, msg, response, body, decoded;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = JSON.stringify(rpcMethod.argValidator.asEncoder().encode(a));
                    msg = transportCodec.asEncoder().encode({ tag: methodName, value: payload });
                    return [4 /*yield*/, transport(JSON.stringify(msg))];
                case 1:
                    response = _a.sent();
                    if (response.isLeft()) {
                        return [2 /*return*/, response];
                    }
                    body = response.unwrap();
                    decoded = rpcMethod.resultValidator.decode(body === undefined ? undefined : JSON.parse(body).result);
                    return [2 /*return*/, decoded
                            .map(function (d) { return either_1.right(d); })
                            .getOrElseL(function () { return either_1.left({ TYPE: 'ERROR_PARSING_BODY', body: body }); })];
            }
        });
    }); };
}
// An example of a ClientTransport that uses HTTP via fetch,
// and adds a csrf token.
var FetchClientTransport = /** @class */ (function () {
    function FetchClientTransport(endpoint, csrfToken, fetcher, httpMethod) {
        if (fetcher === void 0) { fetcher = window.fetch.bind(window); }
        if (httpMethod === void 0) { httpMethod = 'POST'; }
        this.endpoint = endpoint;
        this.csrfToken = csrfToken;
        this.fetcher = fetcher;
        this.httpMethod = httpMethod;
    }
    FetchClientTransport.prototype.transport = function () {
        var _this = this;
        return function (body) { return __awaiter(_this, void 0, void 0, function () {
            var response, _a, e_1, args;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.fetcher(this.endpoint, {
                                method: this.httpMethod,
                                credentials: 'include',
                                redirect: 'manual',
                                headers: { 'x-csrf-token': this.csrfToken },
                                body: body,
                            })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) {
                            throw response;
                        }
                        _a = either_1.right;
                        return [4 /*yield*/, response.text()];
                    case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                    case 3:
                        e_1 = _b.sent();
                        args = ["RPC invocation failed: " + this.endpoint];
                        if (e_1 instanceof Response) {
                            args.push("HTTP Response: status " + e_1.status);
                            args.push(JSON.stringify(e_1.headers, null, 2));
                            args.push("Using csrf token " + this.csrfToken);
                            rollbar_1.error.apply(rollbar_1.error, args);
                            return [2 /*return*/, either_1.left({ TYPE: 'UNEXPECTED_HTTP_RESULT', response: e_1 })];
                        }
                        else {
                            // Should be an Error. Rollbar prolly knows what to do with it.
                            args.push(e_1);
                            rollbar_1.error.apply(rollbar_1.error, args);
                            return [2 /*return*/, either_1.left({ TYPE: 'HTTP_INVOCATION_ERROR', source: e_1 })];
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
    };
    return FetchClientTransport;
}());
exports.FetchClientTransport = FetchClientTransport;
function stubClient(service) {
    return client(service, function () { return Promise.resolve(either_1.left({ TYPE: 'NOT_IMPLEMENTED' })); });
}
exports.stubClient = stubClient;
